<div class="modal__background" @enterLeaveFade (click)="Close()"></div>
@if (open) {
  <div class="modal {{type}}" @enterLeave>
    @switch (type) {
      <!--    Approve modal -->
      @case (ModalType.Approve) {
        @if ((moderationStatus$ | async) === ModerationStatus.SUCCESS) {
          <div class="modal__header modal__header--col">
            <div class="spacer-3"></div>
            <app-svg-icon
              class="icon"
              [src]="'icons/124/circle-check.svg'"
              [svgStyle]="{ 'width.px': '124', 'height.px': '124' }"
            ></app-svg-icon>
            <p class="header-title center">{{ 'MODAL.APPROVAL_PROCESS.INFO_APPROVE.TITLE' | translate }}</p>
            <app-icon-button (action)="Close()" class="icon-button" src="icons/32/close.svg"></app-icon-button>
          </div>
        }
        @if ((moderationStatus$ | async) === ModerationStatus.PENDING || !(moderationStatus$ |async)) {
          <div class="modal__header modal__header--col"
            >
            <div class="spacer-3"></div>
            <app-loading></app-loading>
            <app-icon-button (action)="Close()" class="icon-button" src="icons/32/close.svg"></app-icon-button>
          </div>
        }
        @if ((moderationStatus$ | async) === ModerationStatus.ERROR ) {
          <div class="modal__header modal__header--col">
            <div class="spacer-3"></div>
            <p>{{'MODAL.APPROVAL_PROCESS.INFO_APPROVE.ERROR.TITLE' | translate}}</p>
            <p>{{'MODAL.APPROVAL_PROCESS.INFO_APPROVE.ERROR.TEXT' | translate}}</p>
            <div class="spacer-3"></div>
            <app-icon-button (action)="Close()" class="icon-button" src="icons/32/close.svg"></app-icon-button>
          </div>
        }
        <div class="spacer-and-half"></div>
        @switch (toApproveNumber) {
          @case (0) {
            <p></p>
          }
          @case (1) {
            <p class="center">{{'MODAL.APPROVAL_PROCESS.INFO_APPROVE.TEXT_ONE' | translate}}</p>
          }
          @default {
            <p class="center"
            >{{'MODAL.APPROVAL_PROCESS.INFO_APPROVE.TEXT_MORE' | translate: {value: toApproveNumber} }}</p>
          }
        }
        <div class="spacer-3"></div>
        @if (nextPostPath) {
          <app-button (action)="SetEvent($event, DashboardRoutesType.NewsDetail, nextPostPath)"
            [buttonType]="ButtonType.Primary"
            [label]="'MODAL.APPROVAL_PROCESS.INFO_APPROVE.BUTTON_NEXT' | translate" [fullWidth]="true"
          [extraHeight]="true"></app-button>
        }
        @if (nextPostPath) {
          <div class="spacer-2"></div>
        }
        <app-button (action)="SetEvent($event, DashboardRoutesType.NewsOverview)" [buttonType]="ButtonType.Secondary"
          [label]="'MODAL.APPROVAL_PROCESS.INFO_APPROVE.BUTTON_OVERVIEW' | translate" [fullWidth]="true"
        [extraHeight]="true"></app-button>
      }
      <!--    Decline modal  -->
      @case (ModalType.Decline) {
        @if ((moderationStatus$ | async) === ModerationStatus.PENDING || (moderationStatus$ | async) === ModerationStatus.ERROR
          || (moderationStatus$ | async) === ModerationStatus.SUCCESS) {
          @if ((moderationStatus$ | async) === ModerationStatus.SUCCESS ) {
            <div class="modal__header">
              <p class="header-title">{{ 'MODAL.APPROVAL_PROCESS.INFO_DECLINE.SUCCESS.TITLE' | translate }}</p>
              <app-icon-button (action)="Close()" class="icon-button" src="icons/32/close.svg"></app-icon-button>
            </div>
            <div class="spacer-and-half"></div>
            <p class="center">{{'MODAL.APPROVAL_PROCESS.INFO_DECLINE.SUCCESS.TEXT' | translate}}</p>
            <div class="spacer-3"></div>
            <app-button (action)="SetEvent($event, DashboardRoutesType.NewsOverview)"
              [buttonType]="ButtonType.Secondary"
              [label]="'MODAL.APPROVAL_PROCESS.INFO_APPROVE.BUTTON_OVERVIEW' | translate"
            [fullWidth]="true" [extraHeight]="true"></app-button>
            <div class="spacer-3"></div>
          }
          @if ((moderationStatus$ | async) === ModerationStatus.ERROR ) {
            <div class="modal__header">
              <p class="header-title">{{ 'MODAL.APPROVAL_PROCESS.INFO_DECLINE.ERROR.TITLE' | translate }}</p>
              <app-icon-button (action)="Close()" class="icon-button" src="icons/32/close.svg"></app-icon-button>
            </div>
            <div class="spacer-and-half"></div>
            <p class="center">{{'MODAL.APPROVAL_PROCESS.INFO_DECLINE.ERROR.TEXT' | translate}}</p>
          }
          @if ((moderationStatus$ | async) === ModerationStatus.PENDING ) {
            <div class="modal__header">
              <p class="header-title">{{ 'MODAL.APPROVAL_PROCESS.INFO_DECLINE.PENDING.TITLE' | translate }}</p>
              <app-icon-button (action)="Close()" class="icon-button" src="icons/32/close.svg"></app-icon-button>
            </div>
            <div class="spacer-and-half"></div>
            <p class="center">{{'MODAL.APPROVAL_PROCESS.INFO_DECLINE.PENDING.TEXT' | translate}}</p>
          }
        } @else {
          <div class="modal__header">
            <p class="header-title">{{ 'MODAL.APPROVAL_PROCESS.INFO_DECLINE.TITLE' | translate }}</p>
            <app-icon-button (action)="Close()" class="icon-button" src="icons/32/close.svg"></app-icon-button>
          </div>
          <div class="spacer-and-half"></div>
          <p class="center">{{'MODAL.APPROVAL_PROCESS.INFO_DECLINE.TEXT' | translate}}</p>
          <div class="spacer-2"></div>
          @if (preDecline) {
            <app-input-text-area (currentValue)="declineReason = $event"
            [label]="'MODAL.APPROVAL_PROCESS.INFO_DECLINE.REASON' | translate"></app-input-text-area>
            <div class="spacer-3"></div>
            <app-button [fullWidth]="true" (action)="Decline($event)" [disabled]="declineReason.length === 0"
              [label]="'MODAL.APPROVAL_PROCESS.INFO_DECLINE.BUTTON' | translate"
            [extraHeight]="true"></app-button>
          }
          @if (!preDecline) {
            <app-loading></app-loading>
          }
        }
      }
    }
  </div>
}
